import { Slide } from '@/components/core/Slide';
import audioFile from './21-masters-followup.mp3';

const transcript = `
  Excuses, Jonathan, ik liet me even gaan... het zal niet meer gebeuren.

  Zoals je weet, wil Masters een vervolg op de Food and Fashion shoot die je eerder voor ze gemaakt hebt. \
In die tijd was je zelf nog veel aan het prompten met tools als Midjourney...

  Ik heb zojuist de eerste stap gezet en wat synthografieën klaargezet voor je om te evalueren en richting te 
  bepalen.

  Synthografie is een nieuwe kunstvorm die is ontstaan door de komst van AI-beeldgeneratie. Het is een mix van 
  fotografie en AI, waarbij de AI wordt gebruikt om beelden te genereren die er fotorealistisch uitzien.

  Het verschil met gewone fotografie is dat je niet gebonden bent aan de fysieke wereld. Je kunt alles maken wat 
  je maar kunt bedenken, zolang je het maar goed kunt beschrijven aan de AI.
`;

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="full" autoNext={22500}>
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
